export const pathWithoutQuery = pathname => {
  return pathname.split('?')[0].replace(/\/$/, '');
};
